// Content Loader Utility
// Provides centralized access to content data

import contentData from '../data/content.json';

/**
 * Get content for a specific section
 * @param {string} section - Section name (e.g., 'hero', 'vision', 'contact')
 * @returns {Object} Content object for the section
 */
export function getContent(section) {
  return contentData[section] || {};
}

/**
 * Get all content data
 * @returns {Object} Complete content object
 */
export function getAllContent() {
  return contentData;
}

/**
 * Get hero content
 * @returns {Object} Hero content
 */
export function getHeroContent() {
  return getContent('hero');
}

/**
 * Get services content
 * @returns {Object} Services content
 */
export function getServicesContent() {
  return getContent('services');
}

/**
 * Get vision content
 * @returns {Object} Vision content
 */
export function getVisionContent() {
  return getContent('vision');
}

/**
 * Get newsletter content
 * @returns {Object} Newsletter content
 */
export function getNewsletterContent() {
  return getContent('newsletter');
}

/**
 * Get contact content
 * @returns {Object} Contact content
 */
export function getContactContent() {
  return getContent('contact');
}

/**
 * Get footer content
 * @returns {Object} Footer content
 */
export function getFooterContent() {
  return getContent('footer');
}

/**
 * Network section header copy (titles live in content.json; cards in network.json)
 */
export function getNetworkSectionContent() {
  return getContent('network');
}

